import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

type ScreenSize = 'regular' | 'full';

@Injectable({
  providedIn: 'root',
})
export class ScreenSizeService {
  private readonly screenSize = new BehaviorSubject<ScreenSize>('regular');

  getScreenSizeStyles(): Observable<string> {
    return this.screenSize.asObservable().pipe(
      map((size) => {
        const baseClasses = 'min-w-[1280px] w-full';
        switch (size) {
          case 'regular':
            return baseClasses + ' max-w-[1620px]';
          case 'full':
            return baseClasses + ' max-w-screen';
        }
      }),
    );
  }

  setScreenSize(size: ScreenSize): void {
    this.screenSize.next(size);
  }
}
